import iconPath from '@/assets/device-icons/macbook-pro.svg';

interface MacbookProIconProps {
  className?: string;
}

export const MacbookProIcon = ({ className = "h-5 w-5" }: MacbookProIconProps) => {
  return (
    <img 
      src={iconPath} 
      alt="MacBook Pro" 
      className={className}
    />
  );
};
